import React from 'react';

import classes from 'components/common/Tables/Cells/RelationTypeCell/RelationTypeCell.module.scss';

export const RelationTypeCell = ({ value }: { value: string }) => {
    return <div className={classes.relationType}>{value}</div>;
};
